import { useChargeAccounts } from 'queries/payment'
import { useMemo } from 'react'
import { useAuthContext } from 'components/auth'

export function useHasPaymentMethod() {
  const { company: companyInfo } = useAuthContext()
  const { data: chargeAccounts } = useChargeAccounts()

  const hasPaymentMethod = useMemo(() => {
    if (companyInfo?.chargeUpfront === false) {
      return true
    }

    return !!chargeAccounts?.length
  }, [companyInfo, chargeAccounts])

  return hasPaymentMethod
}
